import axiosHttp from "services/axiosHttp";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

/** GET /order/:id/details — placed sales order detail (line items, totals, warehouse, cashback). */
export const fetchOrderRequestDetail = createAsyncThunk(
	"orderRequests/fetchOrderRequestDetail",
	async ({ id, channel_id } = {}, { rejectWithValue }) => {
		try {
			const qs = channel_id ? `?channel_id=${channel_id}` : "";
			const response = await axiosHttp.get(`order/${id}/details${qs}`);
			return response.data?.data ?? response.data;
		} catch (err) {
			return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch order request detail");
		}
	}
);

const OrderRequestDetailSlice = createSlice({
	name: "OrderRequestDetailSlice",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchOrderRequestDetail.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchOrderRequestDetail.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchOrderRequestDetail.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || action.error?.message;
			});
	},
});

export default OrderRequestDetailSlice.reducer;
